export default __webpack_public_path__ + "static/media/vector1.2fde73f7.jpg";